import { render, staticRenderFns } from "./InvoiceStatusView.vue?vue&type=template&id=720b18a0&scoped=true&"
import script from "./InvoiceStatusView.vue?vue&type=script&lang=ts&"
export * from "./InvoiceStatusView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720b18a0",
  null
  
)

export default component.exports